require('./Step1DepositTransfer.scss')
// @vendors
const React = require('react');
const PropTypes = require("prop-types");
const { formatText, FormattedText } = require('core/i18n').i18n;
// @components
const RiskProduct = require('components/riskProduct/riskProduct');
const santanderLogo = require('assets/images/logoSantander_white.svg');
const { formatInterest } = require('utilities/currencyHelper');
const { OKMessage } = require('commonsComponents/OKMessage');
// @helpers
const currencyHelper = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
// @constants
const { STEP_CONFIG } = require('./constants/step1DepositTransferConfig');
const { COUNTRIES_CODES: { NL, PT, ES } } = require('constants/countries');

import {
    DEFERRAL_DEPOSIT_BLOCKED_ACCOUNT_ACTION_EVENT,
    DEFERRAL_DEPOSIT_PRECONTRACTUAL_LINK_ACTION
} from 'constants/tagging';
import { recordLink } from 'utilities/tagging';
import { getRenewalDepositCategory, getDepositProduct, getMainDepositCategory } from 'utilities/taggingDeposits';

class Step1DepositTransfer extends React.Component {
    constructor (props) {
        super(props)
        const callDocumentsOkApiById = ['depositrenewal', 'depositexpired', 'deposittransfer'].includes(props.immContract.get('name_contract'))

        this.blockedAccountTaggingEmitted = React.createRef(false)
        this.callDocumentsOkApiById = React.createRef()
        this.callDocumentsOkApiById.current = callDocumentsOkApiById
        this.handlePrecontractualDocument = this.handlePrecontractualDocument.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { showBlockedAccountMessage, immContract } = nextProps
        const isBlocked = !immContract.get('renewalDepositAccountBlocked');
        if (showBlockedAccountMessage && isBlocked && immContract.getIn(['mainDeposits', 'data']) && !this.blockedAccountTaggingEmitted.current) {
            const deposit = immContract.getIn(['mainDeposits', 'data']);
            const standard = deposit.get('standard');
            const subType = deposit.get('subtype');
            const type = deposit.get('type');
            const eventCategory = getRenewalDepositCategory(type, subType, standard);
            recordLink(eventCategory, DEFERRAL_DEPOSIT_BLOCKED_ACCOUNT_ACTION_EVENT, getDepositProduct(type, subType, standard))
            this.blockedAccountTaggingEmitted.current = true
        }
    }

    handleLinkClick = () => {
        const { immContract } = this.props;

        const deposit = immContract.getIn(['mainDeposits', 'data']);
        const standard = deposit.get('standard');
        const subType = deposit.get('subtype');
        const type = deposit.get('type');
        const step = immContract.get('visibleStep');

        const eventCategory = this.callDocumentsOkApiById.current
            ? getRenewalDepositCategory(type, subType, standard, step)
            : getMainDepositCategory(type, subType, standard, step)

        recordLink(eventCategory, DEFERRAL_DEPOSIT_PRECONTRACTUAL_LINK_ACTION, formatText('contractsView-contractsView_depositTransferStep1AdvantagesLinkPreContractual'));
        this.callDocumentsOkApiById && this.handlePrecontractualDocument();
    }

    handlePrecontractualDocument = () => {
        const { immContract, getDocumentsOkApiById } = this.props;
        const precontractualDocumentUrl = immContract.get('precontractualDocumentUrl')

        if (precontractualDocumentUrl) {
            window.open(precontractualDocumentUrl, '_blank')
            return
        }
        getDocumentsOkApiById(immContract.get('precontractualDocumentId'), undefined, true)
    }

    render() {
        const { immProfileFields, immAccounts, immFlagBasedFeatures, immContract, immDeposits, showBlockedAccountMessage } = this.props;
        const depositsAllowed = !immContract.getIn(['mainDeposits', 'isFetching']) ? immContract.getIn(['mainDeposits', 'data']).toJS() : null;
        let content;
        if (!depositsAllowed) {
            content = null;
        } else {
            let blockedAccountMessage = null;
            const originCountry = immProfileFields.get('originCountry');
            if (showBlockedAccountMessage) {
                const depositId = immContract.get('renewalOrExpiredDepositId');
                const deposit = immDeposits.getIn(['byId', depositId]);
                const renewalAccount = immAccounts.get('byId').filter(account =>
                (account.get('contractNumber') === deposit.getIn(['impositionAssociatedAccount', 'contractNumber']) &&
                    account.get('product') === deposit.getIn(['impositionAssociatedAccount', 'product']))).first();
                const isBlocked = immContract.get('renewalDepositAccountBlocked');
                const accountAlias = renewalAccount.get('alias');
                const accountIban = `${getLastNChars(renewalAccount.get('iban'))}`;
                const accountType = renewalAccount.get('descProducto').trim();
                const accountBalance = currencyHelper.getFormattedString(renewalAccount.get('balance'));
                blockedAccountMessage = isBlocked ? (
                    <OKMessage type="important">
                        <FormattedText value="contractsView-contractsView_depositRenewalStep1BlockedAccountMessage" injectedStrings={[accountAlias, accountIban, accountType, accountBalance]} />
                    </OKMessage>
                ) : null;
            }

            const isSameTinTae = depositsAllowed.depositConfig.tin === depositsAllowed.depositConfig.tae
            const keyTinTae = [ES].includes(originCountry) && !isSameTinTae ? 'contractsView-contractsView_depositTransferStep1TaeTin' : 'contractsView-contractsView_depositTransferStep1Tae'
            const injectedStringsTinTae = [
                ...([ES].includes(originCountry) ? formatInterest(depositsAllowed.depositConfig.tae, false) : formatInterest(depositsAllowed.depositConfig.tin, false)),
                ...([ES].includes(originCountry) && !isSameTinTae ? formatInterest(depositsAllowed.depositConfig.tin, false) : [])
            ]

            content = (
                <React.Fragment>
                    <RiskProduct
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        isAlertLiquidity={true}
                    />
                    <div className="step1deposittransfer__banner">
                        <p className="step1deposittransfer__banner__title">
                            {formatText('contractsView-contractsView_depositTransferStep1Banner')}
                        </p>
                        <img className="step1deposittransfer__banner__logo" src={santanderLogo} />
                    </div>
                    <h1 className="step1deposittransfer__title">
                        <FormattedText value={`${depositsAllowed.context}-${depositsAllowed.name}`} />
                    </h1>
                    <p className="step1deposittransfer__subtitle">
                        <FormattedText value={STEP_CONFIG[immContract.get('name_contract')].stepSubtitle} injectedStrings={[depositsAllowed.depositConfig.months]} />
                    </p>
                    <div className="step1deposittransfer__product">
                        <div className="step1deposittransfer__product__description">
                            <p className="step1deposittransfer__product__description__months">
                                <FormattedText value={'contractsView-contractsView_depositTransferStep1Months'} injectedStrings={[depositsAllowed.depositConfig.months]} />
                            </p>
                            <FormattedText value={keyTinTae} injectedStrings={injectedStringsTinTae} />
                            {
                                isSameTinTae && ![NL, PT].includes(originCountry) &&
                                <p className="step1deposittransfer__product__description__tin">
                                    {formatText('contractsView-contractsView_depositTransferStep1Tin')}
                                </p>
                            }
                        </div>
                        <div className="step1deposittransfer__product__advantages">
                            <p className="step1deposittransfer__product__advantages__title">
                                {formatText(STEP_CONFIG[immContract.get('name_contract')].stepAdvantagesTitle)}
                            </p>
                            <ul className="step1deposittransfer__product__advantages__list">
                                <li>
                                    <FormattedText value={STEP_CONFIG[immContract.get('name_contract')].stepAdvantagesMessage1} />
                                </li>
                                <li>
                                    <FormattedText value={STEP_CONFIG[immContract.get('name_contract')].stepAdvantagesMessage2} injectedStrings={[formatInterest(depositsAllowed.cancelCost, false)]} />
                                </li>
                                <li>
                                    <FormattedText value={STEP_CONFIG[immContract.get('name_contract')].stepAdvantagesMessage3} />
                                </li>
                            </ul>
                        </div>
                    </div>
                    {
                        this.callDocumentsOkApiById.current ?
                            <a className="step1deposittransfer__legal" onClick={this.handleLinkClick}>
                                {formatText('contractsView-contractsView_depositTransferStep1AdvantagesLinkPreContractual')}
                            </a> :
                            <a className="step1deposittransfer__legal" target="_blank" href={immContract.get('precontractualDocumentUrl')} onClick={this.handleLinkClick}>
                                {formatText('contractsView-contractsView_depositTransferStep1AdvantagesLinkPreContractual')}
                            </a>
                    }
                    {blockedAccountMessage}
                </React.Fragment>
            );
        }
        return (content);
    }
}

Step1DepositTransfer.defaultProps = {
    immAccounts: null,
    showBlockedAccountMessage: false,
    getDocumentsOkApiById: () => { }
};

Step1DepositTransfer.propTypes = {
    getDocumentsOkApiById: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immContract: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immDeposits: PropTypes.object,
    immProfileFields: PropTypes.object,
    showBlockedAccountMessage: PropTypes.bool,
}

module.exports = Step1DepositTransfer;
